let listeners = []

const toQueryString = object =>
  Object.keys(object)
    .map(key => key + "=" + object[key])
    .join("&")

const ReactRB = {
  navigate: {
    go: (path, { params }) => {
      const url = [path, params ? toQueryString(params) : null]
        .filter(Boolean)
        .join("?")

      window.location = url
    },
    refresh: () => {
      window.reload()
    }
  },

  subscribe: fn => {
    listeners.push(fn)
  },
  unsubscribe: fn => {
    listeners = listeners.filter(listener => listener !== fn)
  },
  flash: data => {
    listeners.forEach(fn => fn({ type: "flash", data }))
  }
}

export default ReactRB
